export default __webpack_public_path__ + "static/media/w2.6d7abac8.jpg";